import { connect, ConnectedProps } from "react-redux";
import * as jwt_decode from "jwt-decode";
import * as ImputationsStore from "../../../../redux/middleware/CashFlow-PaymentImputations.Middleware";

// models
import { AppState } from "../../../../redux/reducers";
import { Payment } from "../../../../models/Entities/CashFlow/Payment/Payment";
import { Person } from "../../../../models/Entities/Person/Person";

export interface IProps {
    payment: Payment | null;
    isOpen: boolean;
    onClose: () => void;
    title?: string;
}

const GetPersonByIdentifier = (persons: Person[], tenantId: string, identifier: string): Person | undefined => {
    if (identifier === tenantId) return { personIdentifier: tenantId, businessName: 'Centro Médico' } as Person;
    return persons.find((p: Person) => p.personIdentifier === identifier);
};

const mapStateToProps = (state: AppState, ownProps: IProps) => {
    const persons = state.Persons?.list || [];
    const tenantId = (jwt_decode.jwtDecode(state?.oidc?.user?.access_token!) as any)?.tenantId;

    return {
        GetPersonByIdentifier: (identifier: string) => GetPersonByIdentifier(persons, tenantId, identifier),
        isCreatingImputation: state.CashFlowPaymentImputations?.isCreatingImputation ?? false,
        successCreatingImputation: state.CashFlowPaymentImputations?.successCreatingImputation,
        failOnCreatingImputation: state.CashFlowPaymentImputations?.failOnCreatingImputation ?? false,
    };
};

const mapDispatchToProps = {
    CreatePaymentImputation: ImputationsStore.actionCreators.CreatePaymentImputation,
    GetPaymentImputations: ImputationsStore.actionCreators.GetPaymentImputations,
};

export const connector = connect(mapStateToProps, mapDispatchToProps);
export type Props = IProps & ConnectedProps<typeof connector>;
